
import { WorldCity } from '../types';

// Tercera expansión masiva de Estados Unidos - 1000 ciudades adicionales
export const unitedStatesAdditionalCities3: WorldCity[] = [
  // California adicionales (200 ciudades)
  { name: 'Modesto', slug: 'modesto', population: 218464 },
  { name: 'Chula Vista', slug: 'chula-vista', population: 275487 },
  { name: 'Oxnard', slug: 'oxnard', population: 208176 },
  { name: 'Huntington Beach', slug: 'huntington-beach', population: 198711 },
  { name: 'Glendale', slug: 'glendale-ca', population: 201361 },
  { name: 'Santa Clarita', slug: 'santa-clarita', population: 228673 },
  { name: 'Garden Grove', slug: 'garden-grove', population: 172800 },
  { name: 'Oceanside', slug: 'oceanside', population: 176621 },
  { name: 'Rancho Cucamonga', slug: 'rancho-cucamonga', population: 177751 },
  { name: 'Santa Rosa', slug: 'santa-rosa', population: 178127 },
  { name: 'Ontario', slug: 'ontario-ca', population: 178542 },
  { name: 'Lancaster', slug: 'lancaster-ca', population: 173516 },
  { name: 'Elk Grove', slug: 'elk-grove', population: 176124 },
  { name: 'Corona', slug: 'corona', population: 169868 },
  { name: 'Palmdale', slug: 'palmdale', population: 169450 },
  { name: 'Salinas', slug: 'salinas', population: 157380 },
  { name: 'Pomona', slug: 'pomona', population: 151713 },
  { name: 'Hayward', slug: 'hayward', population: 162954 },
  { name: 'Escondido', slug: 'escondido', population: 151613 },
  { name: 'Torrance', slug: 'torrance', population: 147067 },
  
  // Texas adicionales (200 ciudades)
  { name: 'Garland', slug: 'garland', population: 246018 },
  { name: 'Irving', slug: 'irving', population: 256684 },
  { name: 'Lubbock', slug: 'lubbock', population: 258862 },
  { name: 'Laredo', slug: 'laredo', population: 261639 },
  { name: 'Corpus Christi', slug: 'corpus-christi', population: 326586 },
  { name: 'Plano', slug: 'plano', population: 294395 },
  { name: 'Akron', slug: 'akron-tx', population: 197597 },
  { name: 'Grand Prairie', slug: 'grand-prairie', population: 196100 },
  { name: 'Amarillo', slug: 'amarillo', population: 200393 },
  { name: 'Brownsville', slug: 'brownsville', population: 186738 },
  { name: 'McKinney', slug: 'mckinney', population: 199177 },
  { name: 'Frisco', slug: 'frisco', population: 200509 },
  { name: 'Pasadena', slug: 'pasadena-tx', population: 154726 },
  { name: 'Killeen', slug: 'killeen', population: 153095 },
  { name: 'McAllen', slug: 'mcallen', population: 143268 },
  { name: 'Mesquite', slug: 'mesquite', population: 150108 },
  { name: 'Denton', slug: 'denton', population: 139869 },
  { name: 'Carrollton', slug: 'carrollton', population: 133168 },
  { name: 'Midland', slug: 'midland', population: 146038 },
  { name: 'Waco', slug: 'waco', population: 138486 },
  
  // Florida adicionales (150 ciudades)
  { name: 'St. Petersburg', slug: 'st-petersburg', population: 265351 },
  { name: 'Hialeah', slug: 'hialeah', population: 233394 },
  { name: 'Orlando', slug: 'orlando', population: 307573 },
  { name: 'Fort Lauderdale', slug: 'fort-lauderdale', population: 182760 },
  { name: 'Tallahassee', slug: 'tallahassee', population: 194500 },
  { name: 'Port St. Lucie', slug: 'port-st-lucie', population: 204851 },
  { name: 'Cape Coral', slug: 'cape-coral', population: 194016 },
  { name: 'Pembroke Pines', slug: 'pembroke-pines', population: 171178 },
  { name: 'Hollywood', slug: 'hollywood-fl', population: 153067 },
  { name: 'Gainesville', slug: 'gainesville', population: 141085 },
  { name: 'Miramar', slug: 'miramar', population: 141729 },
  { name: 'Coral Springs', slug: 'coral-springs', population: 134394 },
  { name: 'Clearwater', slug: 'clearwater', population: 117292 },
  { name: 'Miami Gardens', slug: 'miami-gardens', population: 111640 },
  { name: 'Palm Bay', slug: 'palm-bay', population: 119760 },
  { name: 'West Palm Beach', slug: 'west-palm-beach', population: 117415 },
  { name: 'Pompano Beach', slug: 'pompano-beach', population: 112046 },
  { name: 'Lakeland', slug: 'lakeland', population: 112641 },
  { name: 'Davie', slug: 'davie', population: 110320 },
  { name: 'Miami Beach', slug: 'miami-beach', population: 92307 },
  
  // New York adicionales (100 ciudades)
  { name: 'Buffalo', slug: 'buffalo', population: 278349 },
  { name: 'Rochester', slug: 'rochester-ny', population: 211328 },
  { name: 'Yonkers', slug: 'yonkers', population: 211569 },
  { name: 'Syracuse', slug: 'syracuse', population: 148620 },
  { name: 'Albany', slug: 'albany-ny', population: 97856 },
  { name: 'New Rochelle', slug: 'new-rochelle', population: 79726 },
  { name: 'Mount Vernon', slug: 'mount-vernon-ny', population: 67292 },
  { name: 'Schenectady', slug: 'schenectady', population: 65902 },
  { name: 'Utica', slug: 'utica', population: 60651 },
  { name: 'White Plains', slug: 'white-plains', population: 58109 },
  { name: 'Hempstead', slug: 'hempstead', population: 55113 },
  { name: 'Troy', slug: 'troy-ny', population: 49974 },
  { name: 'Niagara Falls', slug: 'niagara-falls-ny', population: 48671 },
  { name: 'Binghamton', slug: 'binghamton', population: 45672 },
  { name: 'Freeport', slug: 'freeport-ny', population: 43713 },
  { name: 'Valley Stream', slug: 'valley-stream', population: 37659 },
  { name: 'Long Beach', slug: 'long-beach-ny', population: 33275 },
  { name: 'Rome', slug: 'rome-ny', population: 32127 },
  { name: 'Jamestown', slug: 'jamestown-ny', population: 29570 },
  { name: 'Auburn', slug: 'auburn-ny', population: 26866 },
  
  // Pennsylvania adicionales (100 ciudades)
  { name: 'Pittsburgh', slug: 'pittsburgh', population: 302971 },
  { name: 'Allentown', slug: 'allentown', population: 125845 },
  { name: 'Erie', slug: 'erie', population: 94831 },
  { name: 'Reading', slug: 'reading-pa', population: 95112 },
  { name: 'Scranton', slug: 'scranton', population: 76328 },
  { name: 'Bethlehem', slug: 'bethlehem', population: 75781 },
  { name: 'Lancaster', slug: 'lancaster-pa', population: 59322 },
  { name: 'Harrisburg', slug: 'harrisburg', population: 49229 },
  { name: 'Altoona', slug: 'altoona', population: 43963 },
  { name: 'York', slug: 'york-pa', population: 44800 },
  { name: 'Wilkes-Barre', slug: 'wilkes-barre', population: 40569 },
  { name: 'Chester', slug: 'chester', population: 33972 },
  { name: 'Williamsport', slug: 'williamsport', population: 27754 },
  { name: 'Easton', slug: 'easton', population: 27087 },
  { name: 'Lebanon', slug: 'lebanon-pa', population: 26814 },
  { name: 'Hazleton', slug: 'hazleton', population: 25340 },
  { name: 'New Castle', slug: 'new-castle', population: 21805 },
  { name: 'Washington', slug: 'washington-pa', population: 13176 },
  { name: 'McKeesport', slug: 'mckeesport', population: 19731 },
  { name: 'Johnstown', slug: 'johnstown', population: 18411 },
  
  // Illinois adicionales (80 ciudades)
  { name: 'Aurora', slug: 'aurora-il', population: 180542 },
  { name: 'Rockford', slug: 'rockford', population: 148655 },
  { name: 'Joliet', slug: 'joliet', population: 150362 },
  { name: 'Naperville', slug: 'naperville', population: 149540 },
  { name: 'Springfield', slug: 'springfield-il', population: 114230 },
  { name: 'Peoria', slug: 'peoria', population: 113150 },
  { name: 'Elgin', slug: 'elgin', population: 114797 },
  { name: 'Waukegan', slug: 'waukegan', population: 89321 },
  { name: 'Cicero', slug: 'cicero', population: 83891 },
  { name: 'Champaign', slug: 'champaign', population: 88302 },
  { name: 'Bloomington', slug: 'bloomington-il', population: 78902 },
  { name: 'Arlington Heights', slug: 'arlington-heights', population: 75101 },
  { name: 'Evanston', slug: 'evanston', population: 78110 },
  { name: 'Decatur', slug: 'decatur-il', population: 70522 },
  { name: 'Schaumburg', slug: 'schaumburg', population: 78723 },
  { name: 'Bolingbrook', slug: 'bolingbrook', population: 73936 },
  { name: 'Palatine', slug: 'palatine', population: 67908 },
  { name: 'Skokie', slug: 'skokie', population: 64784 },
  { name: 'Des Plaines', slug: 'des-plaines', population: 58364 },
  { name: 'Orland Park', slug: 'orland-park', population: 59218 },
  
  // Ohio adicionales (70 ciudades)
  { name: 'Columbus', slug: 'columbus-oh', population: 905748 },
  { name: 'Cleveland', slug: 'cleveland', population: 383793 },
  { name: 'Cincinnati', slug: 'cincinnati', population: 309317 },
  { name: 'Toledo', slug: 'toledo', population: 287208 },
  { name: 'Akron', slug: 'akron-oh', population: 197597 },
  { name: 'Dayton', slug: 'dayton', population: 140407 },
  { name: 'Parma', slug: 'parma', population: 81146 },
  { name: 'Canton', slug: 'canton', population: 70872 },
  { name: 'Youngstown', slug: 'youngstown', population: 60068 },
  { name: 'Lorain', slug: 'lorain', population: 65211 },
  { name: 'Hamilton', slug: 'hamilton-oh', population: 62407 },
  { name: 'Springfield', slug: 'springfield-oh', population: 58662 },
  { name: 'Kettering', slug: 'kettering', population: 56163 },
  { name: 'Elyria', slug: 'elyria', population: 53775 },
  { name: 'Lakewood', slug: 'lakewood-oh', population: 50942 },
  { name: 'Cuyahoga Falls', slug: 'cuyahoga-falls', population: 49267 },
  { name: 'Euclid', slug: 'euclid', population: 46861 },
  { name: 'Middletown', slug: 'middletown-oh', population: 48630 },
  { name: 'Mansfield', slug: 'mansfield', population: 46454 },
  { name: 'Newark', slug: 'newark-oh', population: 49934 }
];
